import Player from '@vimeo/player';
window.Vimeo = { Player : Player };
